import React from 'react'
import { IconTooltip as Tooltip } from '../Tooltip'
import { FaAngleUp, FaAngleDown } from 'react-icons/fa'

const CollapseButton = ({ name, isCollapsed, setCollapsed }) => {
    return (
        <div
            className="panelHeaderIconDiv"
            data-tooltip-content={`Collapse / Expand`}
            data-tooltip-id={`${name}-collapsed-${isCollapsed}`}
            onClick={() => setCollapsed(!isCollapsed)}
        >
            {isCollapsed ? <FaAngleUp /> : <FaAngleDown />}
            <Tooltip id={`${name}-collapsed-${isCollapsed}`} />
        </div>
    )
}

export default CollapseButton
